import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDatosExamenes, getConclusionMedica, postConclusionMedica, patchConclusionMedica } from "../services/api";
import fieldConfig from "../config/fieldConfig";
import { toast } from 'react-toastify';

const RevisarEvaluacion = () => {
    const { evaluacionId } = useParams();
    const navigate = useNavigate();
    const [tiposExamen, setTiposExamen] = useState([]);
    const [conclusion, setConclusion] = useState(null);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        resumen: "",
        recomendaciones: "",
        indicaciones: "",
        guia_medica: ""
    });
    const [vigenciaValor, setVigenciaValor] = useState("0");
    const [vigenciaUnidad, setVigenciaUnidad] = useState("meses");
    const limits = {
        resumen: 550,
        recomendaciones: 250,
        indicaciones: 550,
        guia_medica: 250
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const examRes = await getDatosExamenes(evaluacionId);
                setTiposExamen(examRes.data.examenes || []);

                try {
                    const conclRes = await getConclusionMedica(evaluacionId);
                    setConclusion(conclRes.data);
                    setFormData({
                        resumen: conclRes.data.resumen || "",
                        recomendaciones: conclRes.data.recomendaciones || "",
                        indicaciones: conclRes.data.indicaciones || "",
                        guia_medica: conclRes.data.guia_medica || ""
                    });

                    const meses = conclRes.data.vigencia || 0;
                    if (meses > 0 && meses % 12 === 0) {
                        setVigenciaUnidad("años");
                        setVigenciaValor(String(meses / 12));
                    } else {
                        setVigenciaUnidad("meses");
                        setVigenciaValor(String(meses));
                    }

                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        setConclusion(null);
                    } else {
                        console.error("Error al obtener conclusión médica:", error);
                        toast.error("No se pudo cargar la conclusión médica.");
                    }
                }
            } catch (error) {
                console.error("Error cargando datos de evaluación:", error);
                setError("No se pudieron cargar los datos de la evaluación.");
            }
        };
        fetchData();
    }, [evaluacionId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const maxLength = limits[name];
        const newValue = maxLength ? value.slice(0, maxLength) : value;
        setFormData(prev => ({ ...prev, [name]: newValue }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const vigenciaNumero = Number(vigenciaValor) || 0;
        const vigenciaMeses = vigenciaUnidad === "años" ? vigenciaNumero * 12 : vigenciaNumero;

        const payload = {
            resumen: formData.resumen || "",
            recomendaciones: formData.recomendaciones || "",
            indicaciones: formData.indicaciones || "",
            guia_medica: formData.guia_medica || "",
            vigencia: vigenciaMeses
        };

        try {
            if (conclusion) {
                await patchConclusionMedica(evaluacionId, payload);
            } else {
                await postConclusionMedica(evaluacionId, payload);
            }
            toast.success("Conclusión médica guardada");
            navigate(`/evaluaciones/${evaluacionId}/examenes`);
        } catch (error) {
            console.error("Error guardando conclusión médica:", error);
            toast.error(error.response?.data?.message || "No se pudo guardar la conclusión médica");
        }
    };

    const renderExamenesDatos = (codigo,datos)=> {
        const config = fieldConfig[codigo];
        if(!config||!datos) return null;

        return(
            <div className="examen-datos" >
                {config.map((field)=> {
                    const value = datos[field.name];
                    if(value === undefined || value ===null)return null;
                    let displayValue = value;
                    if(field.type === "checkbox"){
                        displayValue = value ? "Sí":"No";
                    }
                    return(
                        <p key={field.name} >
                            <strong> {field.label}: </strong>
                            {displayValue}
                        </p>
                    )
                })}
            </div>
        );
    };

    if (error) return <p className="required-text">{error}</p>;

    return (
        <div className="content-wrapper">
            <h1>Revisar Evaluación</h1>
            <h2>Exámenes</h2>
            <ul>
                {tiposExamen.map(te => (
                    <li key={te.codigo}>
                        <h3>{te.nombre}</h3>
                        {te.status === "created" ? (
                            <div>
                                <p><strong>Fecha de toma: </strong> {te.datos.fecha_toma}</p>
                                <p> <strong>Fecha disponibilidad: </strong> {te.datos.fecha_disponibilidad || "No definida"}</p>
                                {te.datos.conclusion_examen && (
                                    <div>
                                        <p><strong>Conclusión Examen: </strong> {te.datos.conclusion_examen.estado_conclusion}</p>
                                        <p><strong>Texto: </strong> {te.datos.conclusion_examen.conclusion_txt}</p>
                                    </div>
                                )}
                                {renderExamenesDatos(te.codigo,te.datos)}
                            </div>
                        ) : (
                            <p>No creado</p>
                        )}
                    </li>
                ))}
            </ul>

            <h2>Conclusión Médica</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Resumen</label>
                    <textarea name="resumen" value={formData.resumen || ""} onChange={handleChange} />
                </div>
                <div>
                    <label>Recomendaciones</label>
                    <textarea name="recomendaciones" value={formData.recomendaciones || ""} onChange={handleChange} />
                </div>
                <div>
                    <label>Indicaciones</label>
                    <textarea name="indicaciones" value={formData.indicaciones || ""} onChange={handleChange} />
                </div>
                <div>
                    <label>Guía Médica</label>
                    <input type="text" name="guia_medica" value={formData.guia_medica || ""} onChange={handleChange} />
                </div>
                <div>
                    <label>Vigencia</label>
                    <input
                        type="number"
                        min="0"
                        value={vigenciaValor}
                        onChange={(e) => setVigenciaValor(e.target.value)}
                    />
                    <select value={vigenciaUnidad} onChange={(e) => setVigenciaUnidad(e.target.value)}>
                        <option value="meses">Meses</option>
                        <option value="años">Años</option>
                    </select>
                </div>
                <button type="submit" className="btn btn-submit">Guardar Conclusión Médica</button>
            </form>
        </div>
    );
};

export default RevisarEvaluacion;